import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const Container = styled.div`
  position: relative;
`;

export const Label = styled.label`
  position: absolute;
  top: 3px;
  left: 0;
  width: 34px;
  height: 14px;
  border-radius: 15px;
  background: ${Colors.shade10};
  cursor: pointer;

  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin: -4px;
    background: ${Colors.shade08};
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;

export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 34px;
  height: 14px;

  &:checked + ${Label} {
    background: ${Colors.violet};

    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      margin-left: 21px;
      transition: 0.2s;
    }
  }
`;
